import { Controller } from "@hotwired/stimulus";

// Bulk assign member status: show toolbar when rows selected, submit form with status on button click
export default class extends Controller {
  static targets = ["toolbar", "count", "statusField", "selectAll"];

  updateCount() {
    const checked = this.element.querySelectorAll(".bulk-row-cb:checked");
    const n = checked.length;
    if (this.hasCountTarget) this.countTarget.textContent = n;
    if (this.hasToolbarTarget) this.toolbarTarget.classList.toggle("hidden", n === 0);
    if (this.hasSelectAllTarget) this.selectAllTarget.checked = n > 0 && n === this.element.querySelectorAll(".bulk-row-cb").length;
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.element.querySelectorAll(".bulk-row-cb").forEach((cb) => (cb.checked = checked));
    this.updateCount();
  }

  assign(event) {
    const status = event.target.dataset.status;
    if (!status) return;
    if (this.hasStatusFieldTarget) {
      this.statusFieldTarget.value = status;
      this.element.requestSubmit();
    }
  }
}
